import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class ScrollService {

  _scroll: Subject<any> = new Subject();
  constructor() { 

  }

  setScrollPosition(scrollposition){
    this._scroll.next(scrollposition);
  }

  getScrollPosition(){
    return this._scroll;
  }

}
